"use client";

import type { Photo } from "@/lib/immich/types";
import css from "./PhotoModalViewer.module.css";

export interface PhotoImageProps {
  readonly photo: Photo;
  readonly failed: boolean;
  readonly onError: () => void;
  readonly errorLabel: string;
}

export function PhotoImage({
  photo,
  failed,
  onError,
  errorLabel,
}: PhotoImageProps) {
  if (failed) {
    return (
      <p className={css.errorPlaceholder} role="status">
        {errorLabel}
      </p>
    );
  }
  if (photo.videoUrl) {
    return (
      <video
        key={photo.id}
        src={photo.videoUrl}
        poster={photo.displayUrl}
        controls
        playsInline
        preload="metadata"
        width={photo.width}
        height={photo.height}
        className={css.video}
        aria-label={photo.alt}
        onError={onError}
      />
    );
  }
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      key={photo.id}
      src={photo.displayUrl}
      alt={photo.alt}
      width={photo.width}
      height={photo.height}
      className={css.image}
      onError={onError}
    />
  );
}
